import { Box, Stack } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

import { createExternalInvitationPublic } from '@/domain/external-invitation/actions/create-external-invitation-public.action';
import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSDateField } from '@/ui/components/input/FSDateField';
import { FSPositionGeocodeField } from '@/ui/components/input/FSPositionGeocodeField';
import { useAppDispatch } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

type InviteForm = {
  eventPosition: PositionGeocode | undefined;
  limitDate: string;
};

export function FormExternalPublic({ projectId }: { projectId: number }) {
  const dispatch = useAppDispatch();

  const defaultValues: InviteForm = {
    eventPosition: undefined,
    limitDate: '',
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<InviteForm>({ defaultValues });

  const handleFormSubmit = async (data: InviteForm) => {
    const params = {
      projectId,
      limitDate: data.limitDate,
      eventPosition: data.eventPosition,
    };
    await dispatch(createExternalInvitationPublic(params));
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Stack sx={{ flexDirection: 'column', width: '30rem' }}>
          <Controller
            name="eventPosition"
            rules={{ required: true }}
            control={control}
            render={({ field }) => (
              <FSPositionGeocodeField
                label={translate(
                  'InviteExternalToFill.create-and-send-invitation.event-position',
                )}
                value={field.value}
                required={true}
                onChange={field.onChange}
                error={!!errors.eventPosition}
                helperText={errors.eventPosition?.message}
              />
            )}
          />
          <FSDateField
            label={
              translate(
                'InviteExternalToFill.create-and-send-invitation.limit-date',
              ) +
              ' ' +
              translate('Common.optional-field-label-suffix')
            }
            value=""
            control={control}
            name="limitDate"
            error={!!errors.limitDate}
            helperText={errors.limitDate?.message}
          />
          <Box sx={{ alignSelf: 'flex-end', marginTop: 2 }}>
            <FSPrimaryButton type="submit">
              {translate('ExternalAccessPublic.submit-button-text')}
            </FSPrimaryButton>
          </Box>
        </Stack>
      </form>
    </Box>
  );
}
